﻿<div class="route-component">
    <div class="form-component">
        <h4 *ngIf="tenantId === 0">
            Create New Tenant
        </h4>

        <h4 *ngIf="tenantId > 0">
            Edit Tenant
        </h4>

        <form #form="ngForm" (ngSubmit)="onSave(form)">

            <div class="input-group">
                <label for="tenantName">
                    Tenant Name:<span class="required"> * </span>
                </label>
                <div>
                    <input name="tenantName" #tenantName="ngModel" type="text" placeholder="Tenant Name" [class.invalid]="tenantName.invalid" [(ngModel)]="tenant.tenantName" required>
                    <div *ngIf="tenantName.invalid">
                        <span class="error">Tenant name is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="managerEmail">
                    Manager Email:<span class="required"> * </span>
                </label>
                <div>
                    <input name="managerEmail" #managerEmail="ngModel" type="text" placeholder="Manager Email" [class.invalid]="managerEmail.invalid" [(ngModel)]="tenant.managerEmail" required>
                    <div *ngIf="managerEmail.invalid">
                        <span class="error">Manager email is required</span>
                    </div>
                </div>
            </div>

            <h4 class="section-margin-top">Database Configuration</h4>

            <div class="input-group">
                <label for="host">
                    Host:<span class="required"> * </span>
                </label>
                <div>
                    <input name="host" #host="ngModel" type="text" placeholder="Host" [class.invalid]="host.invalid" [(ngModel)]="tenant.database.host" required>
                    <div *ngIf="host.invalid">
                        <span class="error">Host is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="port">
                    Port:<span class="required"> * </span>
                </label>
                <div>
                    <input name="port" #port="ngModel" type="number" placeholder="Port" [class.invalid]="port.invalid" [(ngModel)]="tenant.database.port" required>
                    <div *ngIf="port.invalid">
                        <span class="error">Port is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="catalog">
                    Catalog:<span class="required"> * </span>
                </label>
                <div>
                    <input name="catalog" #catalog="ngModel" type="text" placeholder="Catalog" [class.invalid]="catalog.invalid" [(ngModel)]="tenant.database.catalog" required>
                    <div *ngIf="catalog.invalid">
                        <span class="error">Catalog is required</span>
                    </div>
                </div>
            </div>

            <div class="input-group">
                <label for="integratedSecurity">
                    Integrated Security:<span class="required"> * </span>
                </label>
                <switch-control
                    name="integratedSecurity"
                    [(ngModel)]="tenant.database.integratedSecurity"
                    (onChange)="clearCredentials()"
                    label="Integrated Security">
                </switch-control>
            </div>

            <div *ngIf="!tenant.database.integratedSecurity" class="input-group">
                <label for="username">
                    Username:<span class="required"> * </span>
                </label>
                <div>
                    <input name="username" #username="ngModel" type="text" placeholder="Username" [class.invalid]="username.invalid" [(ngModel)]="tenant.database.username" required>
                    <div *ngIf="username.invalid">
                        <span class="error">Username is required</span>
                    </div>
                </div>
            </div>

            <div *ngIf="!tenant.database.integratedSecurity" class="input-group">
                <label for="password">
                    Password:<span class="required"> * </span>
                </label>
                <div>
                    <input name="password" #password="ngModel" type="text" placeholder="Password" [class.invalid]="password.invalid" [(ngModel)]="tenant.database.password" required>
                    <div *ngIf="password.invalid">
                        <span class="error">Password is required</span>
                    </div>
                </div>
            </div>

            <div class="action-bar">
                <button type="submit" class="button" [disabled]="form.invalid">
                    <i class="fas fa-save"></i>
                    Save
                </button>
                <button type="button" class="button-cancel" (click)=" onCancel()">
                    <i class="fas fa-cancel"></i> Cancel
                </button>
            </div>
        </form>
    </div>
</div>